/** @format */

import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { reportService } from "../../../Services/report.service";
import { globalServices } from "../../../Services/global.service";
import { storeService } from "../../../Services/store.service";
import SpinnerLoading from "../../Common/SpinnerLoading";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import { useTranslation } from "react-i18next";
import iconcontentcalendar from "../../../Images/Icons/iconcontentcalendar.png";
import { useForm, Controller } from "react-hook-form";
import DatePicker, { registerLocale } from "react-datepicker";
import * as dateHelper from "../../../Helpers/DateHelper";
import Tooltip from "../../../Components/Common/Tooltip";
import { Tabs, Tab } from "react-bootstrap";
import Select from "react-select";
import { AuthContext } from "../../../Contexts/AuthContext";
import hr from "date-fns/locale/hr";
import en from "date-fns/locale/en-US";
import pdfMake from "pdfmake/build/pdfmake";
import { invoiceTotalServices } from "../../../Services/PDFservice/invoicestotal.service";
import pdfFonts from "pdfmake/build/vfs_fonts";
import AsyncSelect from "react-select/async";
import { activeCurrencyByDate } from "../../../Helpers/CurrencyConverter";
import XLSX from "xlsx";
pdfMake.vfs = pdfFonts.pdfMake?.vfs;
registerLocale("hr", hr);
registerLocale("en", en);

const Table = (props) => {
  const {
    updateLocName,
    updateLocPos,
    updateLocTenant,
    updateLocStore,
    updateLocTab,
    selectedLanguageId,
    isMobile,
    locTenant,
  } = useContext(GlobalContext);
  const { t: translator } = useTranslation();
  const { handleSubmit, errors, control, setValue } = useForm({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
  });

  const { userId } = useContext(AuthContext);
  const [reportsDay, setReportsDay] = useState([]);
  const [reportsTaxRate, setReportsTaxRate] = useState([]);
  const [reportsUser, setReportsUser] = useState([]);
  const [reportsProduct, setReportsProduct] = useState([]);
  const [reportsPp, setReportsPp] = useState([]);
  const [reportsPn, setReportsPn] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [storesTag, setStoresTag] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [update, setUpdate] = useState(new Date());
  const [posTag, setPosTag] = useState([]);
  const [key, setKey] = useState("day");
  const [search, setSearch] = useState({
    tenantId:
      Number(localStorage.getItem("tenantId")) > 0
        ? Number(localStorage.getItem("tenantId"))
        : 0,
    posId: 0,
    from: null,
    to: null,
    pageIndex: 0,
    pageSize: 10,
    searchText: "",
  });
  const [reportTag, setReportTag] = useState({
    tenantName: "",
    storeName: "",
    posName: "",
    dateFrom: "",
    dateTo: "",
  });
  const [paginationDay, setPaginationDay] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });
  const [paginationTax, setPaginationTax] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });
  const [paginationUser, setPaginationUser] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });
  const [paginationArticle, setPaginationArticle] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });
  const [paginationPp, setPaginationPp] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });
  const [paginationPn, setPaginationPn] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });

  const [tenantObj, setTenantObj] = useState({
    id: 0,
    label: translator("Select-Tenant"),
    value: translator("Select-Tenant"),
  });
  let reportId = [];

  useEffect(() => {
    if (reportTag.dateFrom != "") {
      handleToSearch();
    }
    TotalTaxRate();
    TotalUser();
    TotalProduct();
    TotalPp();
    TotalPn();
  }, [update]);

  useEffect(() => {
    updateLocName("invoices-invoicesTotal");
    updateLocTenant(0);
    updateLocStore(0);
    updateLocPos(0);
    updateLocTab(0);
  });

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenants(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
        Number(locTenant)
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.name,
        }));

        return result;
      })
      .catch((err) => err);
  };

  const getStores = (tenant) => {
    globalServices
      .getStoresByTenantId(tenant)
      .then((res) => {
        setStoresTag(res.data);
      })
      .catch((err) => console.log(err));
  };

  const getPos = (store) => {
    storeService
      .getPosByStoreId(store)
      .then((res) => {
        setPosTag(res.data);
      })
      .catch((err) => console.log(err));
  };

  const handleToSearch = (event) => {
    let pageI = paginationDay.pageIndex;

    if (event) {
      pageI = 0;
    }

    setIsLoading(true);

    reportService
      .invoicesTotalDay({
        tenantId:
          localStorage.getItem("tenantId") === "null"
            ? Number(search.tenantId)
            : Number(localStorage.getItem("tenantId")),
        posId: search.posId,
        from: search.from,
        to: search.to,
        pageIndex: paginationDay.pageIndex,
        pageSize: paginationDay.pageSize,
      })
      .then((res) => {
        setReportsDay(
          res.data.data.map((p) => {
            return {
              ...p,
              invoiceDate: dateHelper.formatUtcToDate(p.invoiceDate),
            };
          })
        );
        setPaginationDay({
          ...paginationDay,
          totalCount: res.data.totalCount,
          pageIndex: pageI,
        });
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.error(err.response);
      });
  };

  const TotalTaxRate = (event) => {
    let pageI = paginationTax.pageIndex;

    if (event) {
      pageI = 0;
    }

    setIsLoading(true);

    reportService
      .invoicesTotalTaxRate({
        tenantId:
          localStorage.getItem("tenantId") === "null"
            ? Number(search.tenantId)
            : Number(localStorage.getItem("tenantId")),
        posId: search.posId,
        from: search.from,
        to: search.to,
        pageIndex: paginationTax.pageIndex,
        pageSize: paginationTax.pageSize,
      })
      .then((res) => {
        setReportsTaxRate(
          res.data.data.map((p) => {
            return {
              ...p,
              invoiceDate: dateHelper.formatUtcToDate(p.invoiceDate),
            };
          })
        );
        setPaginationTax({
          ...paginationTax,
          totalCount: res.data.totalCount,
          pageIndex: pageI,
        });
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.error(err.response);
      });
  };

  const TotalUser = (event) => {
    let pageI = paginationUser.pageIndex;

    if (event) {
      pageI = 0;
    }

    setIsLoading(true);

    reportService
      .invoicesTotalUser({
        tenantId:
          localStorage.getItem("tenantId") === "null"
            ? Number(search.tenantId)
            : Number(localStorage.getItem("tenantId")),
        posId: search.posId,
        from: search.from,
        to: search.to,
        pageIndex: paginationUser.pageIndex,
        pageSize: paginationUser.pageSize,
      })
      .then((res) => {
        setReportsUser(
          res.data.data.map((p) => {
            return {
              ...p,
              invoiceDate: dateHelper.formatUtcToDate(p.invoiceDate),
            };
          })
        );
        setPaginationUser({
          ...paginationUser,
          totalCount: res.data.totalCount,
          pageIndex: pageI,
        });
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.error(err.response);
      });
  };

  const TotalProduct = (event) => {
    let pageI = paginationArticle.pageIndex;

    if (event) {
      pageI = 0;
    }

    setIsLoading(true);

    reportService
      .invoicesTotalProduct({
        tenantId:
          localStorage.getItem("tenantId") === "null"
            ? Number(search.tenantId)
            : Number(localStorage.getItem("tenantId")),
        posId: search.posId,
        from: search.from,
        to: search.to,
        pageIndex: paginationArticle.pageIndex,
        pageSize: paginationArticle.pageSize,
      })
      .then((res) => {
        setReportsProduct(
          res.data.data.map((p) => {
            return {
              ...p,
              invoiceDate: dateHelper.formatUtcToDate(p.invoiceDate),
            };
          })
        );
        setPaginationArticle({
          ...paginationArticle,
          totalCount: res.data.totalCount,
          pageIndex: pageI,
        });
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.error(err.response);
      });
  };
  const TotalPp = (event) => {
    let pageI = paginationPp.pageIndex;

    if (event) {
      pageI = 0;
    }

    setIsLoading(true);

    reportService
      .invoicesTotalPp({
        tenantId:
          localStorage.getItem("tenantId") === "null"
            ? Number(search.tenantId)
            : Number(localStorage.getItem("tenantId")),
        posId: search.posId,
        from: search.from,
        to: search.to,
        pageIndex: paginationPp.pageIndex,
        pageSize: paginationPp.pageSize,
      })
      .then((res) => {
        setReportsPp(
          res.data.data.map((p) => {
            return {
              ...p,
              invoiceDate: dateHelper.formatUtcToDate(p.invoiceDate),
            };
          })
        );
        setPaginationPp({
          ...paginationPp,
          totalCount: res.data.totalCount,
          pageIndex: pageI,
        });
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.error(err.response);
      });
  };

  const TotalPn = (event) => {
    let pageI = paginationPn.pageIndex;

    if (event) {
      pageI = 0;
    }

    reportService
      .invoicesTotalPn({
        tenantId:
          localStorage.getItem("tenantId") === "null"
            ? Number(search.tenantId)
            : Number(localStorage.getItem("tenantId")),
        posId: search.posId,
        from: search.from,
        to: search.to,
        pageIndex: paginationPn.pageIndex,
        pageSize: paginationPn.pageSize,
      })
      .then((res) => {
        setReportsPn(
          res.data.data.map((p) => {
            return {
              ...p,
              invoiceDate: dateHelper.formatUtcToDate(p.invoiceDate),
            };
          })
        );
        setPaginationPn({
          ...paginationPn,
          totalCount: res.data.totalCount,
          pageIndex: pageI,
        });
      })
      .catch((err) => {
        setIsLoading(false);
        console.error(err);
      });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setSearch({ ...search, [name]: value });
  };

  const handleTableChangeDay = (type, { page, sizePerPage }) => {
    setPaginationDay({
      ...paginationDay,
      pageIndex: sizePerPage != paginationDay.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });

    setUpdate(new Date());
  };

  const handleTableChangeTax = (type, { page, sizePerPage }) => {
    setPaginationTax({
      ...paginationTax,
      pageIndex: sizePerPage != paginationTax.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });

    setUpdate(new Date());
  };

  const handleTableChangeUser = (type, { page, sizePerPage }) => {
    setPaginationUser({
      ...paginationUser,
      pageIndex: sizePerPage != paginationUser.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });

    setUpdate(new Date());
  };

  const handleTableChangeArticle = (type, { page, sizePerPage }) => {
    setPaginationArticle({
      ...paginationArticle,
      pageIndex: sizePerPage != paginationArticle.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });

    setUpdate(new Date());
  };

  const handleTableChangePp = (type, { page, sizePerPage }) => {
    setPaginationPp({
      ...paginationPp,
      pageIndex: sizePerPage != paginationPp.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });

    setUpdate(new Date());
  };

  const handleTableChangePn = (type, { page, sizePerPage }) => {
    setPaginationPn({
      ...paginationPn,
      pageIndex: sizePerPage != paginationPn.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });

    setUpdate(new Date());
  };

  const handleSelect = (key) => {
    setKey();
    switch (key) {
      case "day":
        handleToSearch();
        break;
      case "taxrate":
        TotalTaxRate();
        break;
      case "user":
        TotalUser();
        break;
      case "product":
        TotalProduct();
      case "pp":
        TotalPp();
      case "pn":
        TotalPn();
      default:
        return "day";
    }
  };

  const RemoteAll = ({ data, page, sizePerPage, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        showHeader={false}
        remote
        keyField="reportId"
        data={data}
        columns={columnsDay}
        noDataIndication={translator("No-Data")}
        rowClasses="boostrap-table-row"
        pagination={paginationFactory({
          page,
          hideSizePerPage: true,
          totalSize,
        })}
        onTableChange={onTableChange}
        footerClasses={"footer-background"}
      />
    </div>
  );

  const RemoteAllTaxRate = ({ data, page, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        showHeader={false}
        remote
        keyField="taxRateId"
        data={data}
        columns={columnsTaxRate}
        noDataIndication={translator("No-Data")}
        rowClasses="boostrap-table-row"
        pagination={paginationFactory({
          page,
          hideSizePerPage: true,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  const RemoteAllUser = ({ data, page, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        showHeader={false}
        remote
        keyField="userGuid"
        data={data}
        columns={columnsUser}
        noDataIndication={translator("No-Data")}
        rowClasses="boostrap-table-row"
        pagination={paginationFactory({
          page,
          hideSizePerPage: true,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  const RemoteAllProduct = ({ data, page, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        showHeader={false}
        remote
        keyField="productGuid"
        data={data}
        columns={columnsProduct}
        noDataIndication={translator("No-Data")}
        rowClasses="boostrap-table-row"
        pagination={paginationFactory({
          page,
          hideSizePerPage: true,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  const RemoteAllPp = ({ data, page, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        showHeader={false}
        remote
        keyField="productGuid"
        data={data}
        columns={columnsPp}
        noDataIndication={translator("No-Data")}
        rowClasses="boostrap-table-row"
        pagination={paginationFactory({
          page,
          hideSizePerPage: true,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  const RemoteAllPn = ({ data, page, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        showHeader={false}
        remote
        keyField="productGuid"
        data={data}
        columns={columnsPn}
        noDataIndication={translator("No-Data")}
        rowClasses="boostrap-table-row"
        pagination={paginationFactory({
          page,
          hideSizePerPage: true,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  function dateTimeFormatter(cell, row) {
    return new Intl.DateTimeFormat("hr", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour12: false,
      timeZone: "Europe/Zagreb",
    }).format(new Date(cell));
  }
  function currencyFormatter(cell, row) {
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: activeCurrencyByDate(search?.to),
    }).format(Number(cell));
  }

  const columnsDay = [
    {
      dataField: "invoiceDate",
      text: translator("Report-View-TableHeader-invoiceDate"),
    },
    {
      dataField: "amount",
      text: translator("Report-View-TableHeader-Amount"),
      formatter: currencyFormatter,
      headerStyle: () => {
        return { width: "150px", textAlign: "right" };
      },
      style: () => {
        return { width: "150px", textAlign: "right" };
      },
      hidden: Boolean(isMobile),
    },
  ];

  const columnsTaxRate = [
    {
      dataField: "taxRateName",
      text: translator("Report-View-TableHeader-TotalTaxRateName"),
    },
    {
      dataField: "taxRate",
      text: translator("Report-View-TableHeader-TotalTaxRate"),
      hidden: Boolean(isMobile),
    },
    {
      dataField: "totalGroupPayValue",
      text: translator("Report-View-TableHeader-TotalGroupPayValue"),

      formatter: currencyFormatter,
      headerStyle: () => {
        return { width: "150px", textAlign: "right" };
      },
      style: () => {
        return { width: "150px", textAlign: "right" };
      },
      hidden: Boolean(isMobile),
    },
    {
      dataField: "totalGroupTaxValue",
      text: translator("Report-View-TableHeader-TotalGroupTaxValue"),
      formatter: currencyFormatter,
      headerStyle: () => {
        return { width: "150px", textAlign: "right" };
      },
      style: () => {
        return { width: "150px", textAlign: "right" };
      },
      hidden: Boolean(isMobile),
    },
  ];

  const columnsUser = [
    {
      dataField: "userPrintName",
      text: translator("Report-View-TableHeader-UserPrintName"),
    },
    {
      dataField: "amount",
      text: translator("Report-View-TableHeader-Amount"),
      formatter: currencyFormatter,
      headerStyle: () => {
        return { width: "150px", textAlign: "right" };
      },
      style: () => {
        return { width: "150px", textAlign: "right" };
      },
    },
  ];

  const columnsProduct = [
    {
      dataField: "productName",
      text: translator("Report-View-TableHeader-ProductName"),
    },
    {
      dataField: "quantity",
      text: translator("Report-View-TableHeader-Qty"),
      headerStyle: () => {
        return { width: "150px", textAlign: "right" };
      },
      style: () => {
        return { width: "150px", textAlign: "right" };
      },
    },
    {
      dataField: "amount",
      text: translator("Report-View-TableHeader-Amount"),
      formatter: currencyFormatter,
      headerStyle: () => {
        return { width: "150px", textAlign: "right" };
      },
      style: () => {
        return { width: "150px", textAlign: "right" };
      },
    },
  ];

  const columnsPp = [
    {
      dataField: "posTag",
      text: translator("Report-View-TableHeader-ProductName"),
    },
    {
      dataField: "pp",
      text: translator("pp"),
      hidden: Boolean(isMobile),
    },
    {
      dataField: "amount",
      text: translator("Report-View-TableHeader-Amount"),
      formatter: currencyFormatter,
      headerStyle: () => {
        return { width: "150px", textAlign: "right" };
      },
      style: () => {
        return { width: "150px", textAlign: "right" };
      },
      hidden: Boolean(isMobile),
    },
  ];

  const columnsPn = [
    {
      dataField: "amount",
      text: translator("Report-View-TableHeader-Amount"),
      formatter: currencyFormatter,
      headerStyle: () => {
        return { width: "150px", textAlign: "right" };
      },
      style: () => {
        return { width: "150px", textAlign: "right" };
      },
    },
  ];

  const exportFunction = () => {
    Promise.all([
      reportService.invoicesTotalDay({
        tenantId: Number(search.tenantId),
        posId: search.posId,
        from: search.from,
        to: search.to,
        pageIndex: search.pageIndex,
        pageSize: 0,
      }),
      reportService.invoicesTotalTaxRate({
        tenantId: Number(search.tenantId),
        posId: search.posId,
        from: search.from,
        to: search.to,
        pageIndex: search.pageIndex,
        pageSize: 0,
      }),
      reportService.invoicesTotalUser({
        tenantId: Number(search.tenantId),
        posId: search.posId,
        from: search.from,
        to: search.to,
        pageIndex: search.pageIndex,
        pageSize: 0,
      }),
      reportService.invoicesTotalProduct({
        tenantId: Number(search.tenantId),
        posId: search.posId,
        from: search.from,
        to: search.to,
        pageIndex: search.pageIndex,
        pageSize: 0,
      }),
      reportService.invoicesTotalPp({
        tenantId: Number(search.tenantId),
        posId: search.posId,
        from: search.from,
        to: search.to,
        pageIndex: search.pageIndex,
        pageSize: 0,
      }),
      reportService.invoicesTotalPn({
        tenantId: Number(search.tenantId),
        posId: search.posId,
        from: search.from,
        to: search.to,
        pageIndex: search.pageIndex,
        pageSize: 0,
      }),
    ]).then((values) => {
      invoiceTotalServices.handlePrint(
        values[0].data.data,
        values[1].data.data,
        values[2].data.data,
        values[3].data.data,
        values[4].data.data,
        values[5].data.data,
        translator,
        reportTag
      );
    });
  };

  const exportExcelFunction = () => {
    Promise.all([
      reportService.invoicesTotalDay({
        tenantId: Number(search.tenantId),
        posId: search.posId,
        from: search.from,
        to: search.to,
        pageIndex: search.pageIndex,
        pageSize: 0,
      }),
      reportService.invoicesTotalTaxRate({
        tenantId: Number(search.tenantId),
        posId: search.posId,
        from: search.from,
        to: search.to,
        pageIndex: search.pageIndex,
        pageSize: 0,
      }),
      reportService.invoicesTotalUser({
        tenantId: Number(search.tenantId),
        posId: search.posId,
        from: search.from,
        to: search.to,
        pageIndex: search.pageIndex,
        pageSize: 0,
      }),
      reportService.invoicesTotalProduct({
        tenantId: Number(search.tenantId),
        posId: search.posId,
        from: search.from,
        to: search.to,
        pageIndex: search.pageIndex,
        pageSize: 0,
      }),
      reportService.invoicesTotalPp({
        tenantId: Number(search.tenantId),
        posId: search.posId,
        from: search.from,
        to: search.to,
        pageIndex: search.pageIndex,
        pageSize: 0,
      }),
      reportService.invoicesTotalPn({
        tenantId: Number(search.tenantId),
        posId: search.posId,
        from: search.from,
        to: search.to,
        pageIndex: search.pageIndex,
        pageSize: 0,
      }),
    ])
      .then((res) => {
        // File name
        var ws_name = `${translator("InvTotalReport-Title").slice(0, 25)}.xlsx`;
        // New work book
        var wb = XLSX.utils.book_new();
        // Constant Data
        var ws_data = [
          [translator("InvIssReport-Filters-Tenants"), tenantObj.label],
          [
            "Period",
            `${new Intl.DateTimeFormat("hr", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
            }).format(new Date(search.from))} - ${new Intl.DateTimeFormat(
              "hr",
              {
                year: "numeric",
                month: "numeric",
                day: "numeric",
              }
            ).format(new Date(search.to))}`,
          ],
          [],
          [
            translator("InvoicesTotalPDF-InvoiceDate"),
            translator("InvCashBalance-Amount"),
          ],
        ];

        let ws_sufix = res[0].data.data.map((x) => {
          const array = [dateTimeFormatter(x.invoiceDate), x.amount];
          return array;
        });
        ws_data = [...ws_data, ...ws_sufix];

        let ws_data2 = [
          [
            translator("InvoicesTotalPDF-Name"),
            translator("InvoicesTotalPDF-TaxRate"),
            translator("InvoicesTotalPDF-TotalPayValue"),
            translator("InvoicesTotalPDF-TotalTaxValue"),
          ],
        ];
        let ws_sufix2 = res[1].data.data.map((x) => {
          const array = [
            x.taxRateName,
            x.taxRate,
            x.totalGroupPayValue,
            x.totalGroupTaxValue,
          ];
          return array;
        });
        ws_data2 = [...ws_data2, ...ws_sufix2];

        let ws_data3 = [
          [
            translator("Print naziv blagajnika"),
            translator("InvCashBalance-Amount"),
          ],
        ];
        let ws_sufix3 = res[2].data.data.map((x) => {
          const array = [x.userPrintName, x.amount];
          return array;
        });
        ws_data3 = [...ws_data3, ...ws_sufix3];

        let ws_data4 = [
          [
            translator("InvoicesTotalPDF-Name"),
            translator("Report-View-TableHeader-Qty"),
            translator("InvCashBalance-Amount"),
          ],
        ];
        let ws_sufix4 = res[3].data.data.map((x) => {
          const array = [x.productName, x.quantity, x.amount];
          return array;
        });
        ws_data4 = [...ws_data4, ...ws_sufix4];

        let ws_data5 = [
          [
            translator("InvoicesTotalPDF-Name"),
            translator("Report-InvTotal-pp"),
            translator("InvCashBalance-Amount"),
          ],
        ];
        let ws_sufix5 = res[4].data.data.map((x) => {
          const array = [x.productName, x.pp, x.amount];
          return array;
        });
        ws_data5 = [...ws_data5, ...ws_sufix5];

        let ws_data6 = [[translator("InvCashBalance-Amount")]];
        let ws_sufix6 = res[5].data.data.map((x) => {
          const array = [x.amount];
          return array;
        });
        ws_data6 = [...ws_data6, ...ws_sufix6];
        // Export to xlsx
        const ws = XLSX.utils.aoa_to_sheet(ws_data);
        const ws2 = XLSX.utils.aoa_to_sheet(ws_data2);
        const ws3 = XLSX.utils.aoa_to_sheet(ws_data3);
        const ws4 = XLSX.utils.aoa_to_sheet(ws_data4);
        const ws5 = XLSX.utils.aoa_to_sheet(ws_data5);
        const ws6 = XLSX.utils.aoa_to_sheet(ws_data6);

        ws["!cols"] = [
          { width: 20 },
          { width: 30 },
          { width: 20 },
          { width: 20 },
        ];

        ws2["!cols"] = [
          { width: 20 },
          { width: 20 },
          { width: 30 },
          { width: 30 },
        ];
        ws3["!cols"] = ws["!cols"];
        ws4["!cols"] = ws["!cols"];
        ws5["!cols"] = ws["!cols"];
        ws6["!cols"] = ws["!cols"];
        try {
          XLSX.utils.book_append_sheet(wb, ws, "Dnevni utržak");
          XLSX.utils.book_append_sheet(wb, ws2, "Utržak po porezu");
          XLSX.utils.book_append_sheet(wb, ws3, "Utržak po blagajniku");
          XLSX.utils.book_append_sheet(wb, ws4, "Utržak po artiklima");
          XLSX.utils.book_append_sheet(wb, ws5, "Utržak prema PP");
          XLSX.utils.book_append_sheet(wb, ws6, "Utržak prema PN");
          XLSX.writeFile(wb, ws_name);
        } catch (err) {
          console.log(err);
        }
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("InvTotalReport-Title")}</span>
        </div>

        <div className="card-body">
          <fieldset className="scheduler-border">
            <form className="row" onSubmit={handleSubmit(handleToSearch)}>
              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                    <label htmlFor="ddlTenants">
                      {translator("InvIssReport-Filters-Tenants")}
                    </label>
                    <Controller
                      as={AsyncSelect}
                      control={control}
                      name="tenantId"
                      rules={{
                        validate: function (value) {
                          if (!value) return false;
                          return value.value === 0 ? false : true;
                        },
                      }}
                      onChange={function (event) {
                        setValue("storeTag", null);
                        setValue("posTag", null);
                        setTenantObj({
                          id: event[0].id,
                          label: event[0].label,
                          value: event[0].value,
                        });
                        setSearch({
                          ...search,
                          tenantId: event[0].id,
                        });
                        setReportTag({
                          ...reportTag,
                          tenantName: event[0].label,
                        });
                        getStores(event[0].id);
                        // setReportsDay([]);
                        // setReportsTaxRate([]);
                        // setReportsUser([]);
                        // setReportsProduct([]);
                        // setReportsPp([]);
                        // setReportsPn([]);

                        return event[0];
                      }}
                      defaultOptions={true}
                      loadOptions={promiseOptions}
                      placeholder={translator("Select-Tenant")}
                      value={tenantObj}
                    />
                    {errors.tenantId && errors.tenantId.type === "validate" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  </div>
                </>
              }

              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                    <label>{translator("InvIssReport-Filters-StoreTag")}</label>{" "}
                    <Tooltip text={translator("StoreTagTooltip-Msg")} />
                    <Controller
                      as={Select}
                      control={control}
                      autoComplete="off"
                      name="storeTag"
                      placeholder={translator("SelectStoreTag")}
                      rules={{ required: true }}
                      onChange={function (event) {
                        setValue("posTag", null);
                        setSearch({
                          ...search,
                          storeTag: event[0].value,
                        });
                        setReportTag({
                          ...reportTag,
                          storeName: event[0].label,
                        });
                        getPos(event[0].id);
                        // setReportsDay([]);
                        // setReportsTaxRate([]);
                        // setReportsUser([]);
                        // setReportsProduct([]);
                        // setReportsPp([]);
                        // setReportsPn([]);

                        return event[0];
                      }}
                      options={
                        storesTag &&
                        storesTag.map((e) => ({
                          id: e.id,
                          label: e.tag,
                          value: e.name,
                        }))
                      }
                    />
                    {errors.storeTag && (
                      <>
                        {errors.storeTag.type === "required" && (
                          <p className="text-danger">
                            {translator("ValidationMsg-RequiredField")}
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </>
              }

              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                    <label>{translator("InvIssReport-Filters-PosTag")}</label>{" "}
                    <Tooltip text={translator("PosTagTooltip-Msg")} />
                    <Controller
                      as={Select}
                      control={control}
                      autoComplete="off"
                      placeholder={translator("SelectStoreTag")}
                      name="posTag"
                      rules={{ required: true }}
                      onChange={function (event) {
                        setSearch({
                          ...search,
                          posId: event[0].id,
                        });
                        setReportTag({
                          ...reportTag,
                          posName: event[0].label,
                        });
                        // setReportsDay([]);
                        // setReportsTaxRate([]);
                        // setReportsUser([]);
                        // setReportsProduct([]);
                        // setReportsPp([]);
                        // setReportsPn([]);
                        return event[0];
                      }}
                      options={
                        posTag &&
                        posTag.map((e) => ({
                          id: e.posid,
                          label: e.tag,
                          value: e.tag,
                        }))
                      }
                    />
                    {errors.posTag && (
                      <>
                        {errors.posTag.type === "required" && (
                          <p className="text-danger">
                            {translator("ValidationMsg-RequiredField")}
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </>
              }
              <div className="form-group col-lg-3 col-md-4 col-sm-6 col-xs-12"></div>
              {
                <>
                  <div className="form-group col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <label>{translator("InvIssReport-ValidFrom")}</label>
                    <div className="input-group mb-2">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          <img src={iconcontentcalendar} alt="calendar" />
                        </span>
                      </div>
                      <Controller
                        maxDate={search && search.to && new Date(search.to)}
                        as={DatePicker}
                        control={control}
                        autoComplete="off"
                        className="form-control"
                        dateFormat="dd.MM.yyyy"
                        showYearDropdown={true}
                        name="from"
                        locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                        rules={{ required: true }}
                        valueName="selected"
                        onChange={function ([selected]) {
                          handleInputChange({
                            target: {
                              name: "from",
                              value: dateHelper.datePickerDateToUtc(selected),
                            },
                          });
                          setReportTag({
                            ...reportTag,
                            dateFrom: selected,
                          });
                          setValue("to", null);
                          return selected;
                        }}
                      />
                    </div>
                    {errors.from && errors.from.type === "required" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  </div>
                </>
              }

              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label>{translator("InvIssReport-ValidTo")}</label>
                    <div className="input-group mb-2">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          <img src={iconcontentcalendar} alt="calendar" />
                        </span>
                      </div>
                      <Controller
                        disabled={search && search.from ? false : true}
                        as={DatePicker}
                        minDate={search && search.from && new Date(search.from)}
                        maxDate={
                          search &&
                          search.from &&
                          new Date(new Date(search.from).getFullYear(), 11, 31)
                        }
                        control={control}
                        autoComplete="off"
                        className="form-control"
                        dateFormat="dd.MM.yyyy"
                        showYearDropdown={true}
                        name="to"
                        rules={{ required: true }}
                        locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                        valueName="selected"
                        onChange={function ([selected]) {
                          handleInputChange({
                            target: {
                              name: "to",
                              value: dateHelper.datePickerDateToUtc(selected),
                            },
                          });
                          setReportTag({
                            ...reportTag,
                            dateTo: selected,
                          });
                          return selected;
                        }}
                      />
                    </div>
                    {errors.to && errors.to.type === "required" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  </div>
                </>
              }
              {
                <>
                  <div className="form-group col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <label>{""}</label>
                    <div className="form-group">
                      <button
                        className="btn btn-primary pull-left mt-2"
                        type="submit"
                      >
                        <span className="icon icon-search"></span>{" "}
                        {translator("InvIssReport-Btn-Search")}
                      </button>
                    </div>
                  </div>
                </>
              }
            </form>
          </fieldset>
        </div>
        <div className="col-lg-12 mt-2">
          <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={handleSelect}
            variant="tabs"
          >
            <Tab
              eventKey="day"
              title={translator("ReportsTotal-DailyEarnings")}
              key="day"
              tabClassName="mob-tabs"
            >
              <div className="p-2">
                <div className="container-fluid p-0">
                  <div className="card-body pl-0 mb-4 col-md-12">
                    {isLoading && (
                      <div className="dashboard-card-spinner">
                        <SpinnerLoading />
                      </div>
                    )}
                    {!isLoading && (
                      <RemoteAll
                        data={reportsDay}
                        page={paginationDay.pageIndex + 1}
                        sizePerPage={paginationDay.pageSize}
                        totalSize={paginationDay.totalCount}
                        onTableChange={handleTableChangeDay}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Tab>
            <Tab
              key="taxrate"
              eventKey="taxrate"
              title={translator("ReportsTotal-EarningsTax")}
              tabClassName="mob-tabs"
            >
              <div className="p-2">
                <div className="container-fluid p-0">
                  <div className="card-body pl-0 mb-4 col-md-12">
                    {isLoading && (
                      <div className="dashboard-card-spinner">
                        <SpinnerLoading />
                      </div>
                    )}
                    {!isLoading && (
                      <RemoteAllTaxRate
                        data={reportsTaxRate}
                        page={paginationTax.pageIndex + 1}
                        sizePerPage={paginationTax.pageSize}
                        totalSize={paginationTax.totalCount}
                        onTableChange={handleTableChangeTax}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Tab>
            <Tab
              key="user"
              eventKey="user"
              title={translator("ReportsTotal-EarningsPerOperator")}
              tabClassName="mob-tabs"
            >
              <div className="p-2">
                <div className="container-fluid p-0">
                  <div className="card-body pl-0 mb-4 col-md-12">
                    {isLoading && (
                      <div className="dashboard-card-spinner">
                        <SpinnerLoading />
                      </div>
                    )}
                    {!isLoading && (
                      <RemoteAllUser
                        data={reportsUser}
                        page={paginationUser.pageIndex + 1}
                        sizePerPage={paginationUser.pageSize}
                        totalSize={paginationUser.totalCount}
                        onTableChange={handleTableChangeUser}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Tab>
            <Tab
              key="product"
              eventKey="product"
              title={translator("ReportsTotal-EarningsPerItem")}
              tabClassName="mob-tabs"
            >
              <div className="p-2">
                <div className="container-fluid p-0">
                  <div className="card-body pl-0 mb-4 col-md-12">
                    {isLoading && (
                      <div className="dashboard-card-spinner">
                        <SpinnerLoading />
                      </div>
                    )}
                    {!isLoading && (
                      <RemoteAllProduct
                        data={reportsProduct}
                        page={paginationArticle.pageIndex + 1}
                        sizePerPage={paginationArticle.pageSize}
                        totalSize={paginationArticle.totalCount}
                        onTableChange={handleTableChangeArticle}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Tab>
            <Tab
              key="pp"
              eventKey="pp"
              title={translator("InvTotalReportPDF-RevenuePerPp")}
              tabClassName="mob-tabs"
            >
              <div className="p-2">
                <div className="container-fluid p-0">
                  <div className="card-body pl-0 mb-4 col-md-12">
                    {isLoading && (
                      <div className="dashboard-card-spinner">
                        <SpinnerLoading />
                      </div>
                    )}
                    {!isLoading && (
                      <RemoteAllPp
                        data={reportsPp}
                        page={paginationPp.pageIndex + 1}
                        sizePerPage={paginationPp.pageSize}
                        totalSize={paginationPp.totalCount}
                        onTableChange={handleTableChangePp}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Tab>
            <Tab
              key="pn"
              eventKey="pn"
              title={translator("InvTotalReportPDF-RevenuePerPn")}
              tabClassName="mob-tabs"
            >
              <div className="p-2">
                <div className="container-fluid p-0">
                  <div className="card-body pl-0 mb-4 col-md-12">
                    {/* {isLoading && (
                      <div className="dashboard-card-spinner">
                        <SpinnerLoading />
                      </div>
                    )} */}
                    {/* {!isLoading && ( */}
                    <RemoteAllPn
                      data={reportsPn}
                      page={paginationPn.pageIndex + 1}
                      sizePerPage={paginationPn.pageSize}
                      totalSize={paginationPn.totalCount}
                      onTableChange={handleTableChangePn}
                    />
                    {/* )} */}
                  </div>
                </div>
              </div>
            </Tab>
          </Tabs>

          {reportsDay.length !== 0 ? (
            <>
              <button
                className="btn btn-outline-secondary"
                onClick={exportFunction}
              >
                <i className="fas fa-file-pdf"></i>{" "}
                {translator("Reports-PrintBtn")}
              </button>
              {"  "}
              <button
                className="btn btn-outline-secondary"
                onClick={exportExcelFunction}
              >
                <i className="fas fa-file-alt"></i>{" "}
                {translator("Reports-PrintExclBtn")}
              </button>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default Table;
